import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';


function ExtraloadingIndex() {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');



    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchExtras();
    }, [isAuthenticated, companyId, token, logout]);
    const fetchExtras = async () => {
        try {
            const response = await fetchData('ExtraLoadingIndexAPI', `/${companyId}/${id}`, token);

            if (response.responseCode === '1111') {
                console.log(response);
                setData(response.response_data);
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.error('API not found (404). Check the endpoint:', error.response);
            } else {
                console.error('Error fetching order details:', error);
            }
        }
    };

    return (
        <div style={{ maxWidth: '100%', padding: '16px', backgroundColor: '#f0f7f4', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', margin: '20px auto' }}>
            
            {/* Header Section */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #6b4c7a' }}>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#6b4c7a', fontFamily: 'Arial, sans-serif', textTransform: 'uppercase' }}>
                    Extra Loading List
                </h2>
                {hasCreateMasterPermission && (
                    <Link to={`/Extraloading/${id}`} style={{ textDecoration: 'none' }}>
                        <Tooltip title="Create Extra Loading">
                            <Button 
                                variant="contained"
                                style={{ 
                                    height: '36px',
                                    fontSize: '12px',
                                    backgroundColor: '#10a37f',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    borderRadius: '18px',
                                    textTransform: 'none',
                                    padding: '0 20px'
                                }}
                            >
                                <AddIcon style={{ fontSize: '18px', marginRight: '4px' }} />
                                Create
                            </Button>
                        </Tooltip>
                    </Link>
                )}
            </div>

            {/* Table Section */}
            <div style={{ maxHeight: '600px', overflowY: 'auto', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#6b4c7a' }}>
                            <TableRow>
                                <TableCell style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Trip Description</TableCell>
                                <TableCell style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Sale Remarks</TableCell>
                                <TableCell style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'center' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data && data.length > 0 ? (
                                data.map((item, index) => (
                                    <TableRow 
                                        key={item.id} 
                                        style={{ 
                                            backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                                            borderBottom: '1px solid #dee2e6'
                                        }}
                                    >
                                        <TableCell style={{ fontSize: '11px', padding: '6px', color: '#2c3e50', borderRight: '1px solid #dee2e6' }}>
                                            {item.tripdetails}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '11px', padding: '6px', color: '#2c3e50', borderRight: '1px solid #dee2e6' }}>
                                            {item.saleRemarks}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '11px', padding: '6px', textAlign: 'center' }}>
                                            {hasEditMasterPermission && (
                                                <Link to={`/ExtraLoadingEdit/${item.id}`}>
                                                    <Tooltip title="Edit Extra Loading">
                                                        <IconButton size="small">
                                                            <EditIcon style={{ color: '#6b4c7a', fontSize: '18px' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={3} style={{ textAlign: 'center', padding: '40px', color: '#6c757d', fontSize: '14px' }}>
                                        No extra loading records found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default ExtraloadingIndex;
